import React from 'react';
import HeaderAdmin from '../adminpanel/components/HeaderAdmin/HeaderAdmin';
import SidebarAdmin from '../adminpanel/components/SidebarAdmin/SidebarAdmin';
import CSSLoader from './CSSLoader';

const AdminLayout = ({ children, userLogout, isAuthenticated }) => (
  <div className="admin-app">
    <CSSLoader /> 
    {isAuthenticated && <HeaderAdmin userLogout={userLogout} />}
    <div className="admin">
      {isAuthenticated && <SidebarAdmin />}
      {children}
    </div>
  </div>
);

export default AdminLayout;